import Vue from 'vue'
import Router from 'vue-router'
import axios from '../axios'
import store from '../store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/Index'),
      meta: {
        checkLogin: true,
        title: '首頁',
      },
      children: [
        {
          path: '/member/search',
          name: 'memberSearch',
          component: () => import('@/views/Member/Search'),
          meta: {
            checkLogin: true,
            title: '會員搜尋',
          }
        },
        {
          path: '/member/agent',
          name: 'memberAgent',
          component: () => import('@/views/Member/Agent'),
          meta: {
            checkLogin: true,
            title: '代理管理',
          }
        },
        {
          path: '/member/verifyBank',
          name: 'memberVerifyBank',
          component: () => import('@/views/Member/VerifyBank'),
          meta: {
            checkLogin: true,
            title: '銀行審核',
          }
        },
        {
          path: '/member/admin',
          name: 'memberAdmin',
          component: () => import('@/views/Member/Admin'),
          meta: {
            checkLogin: true,
            title: '子賬號管理',
          }
        },
        {
          path: '/member/auth',
          name: 'memberAuth',
          component: () => import('@/views/Member/Auth'),
          meta: {
            checkLogin: true,
            title: '權限設定',
          }
        },
        {
          path: '/member/verification',
          name: 'memberVerification',
          component: () => import('@/views/Member/Verification'),
          meta: {
            checkLogin: true,
            title: '驗證紀錄',
          }
        },
        {
          path: '/wallet/record',
          name: 'walletRecord',
          component: () => import('@/views/Wallet/Record'),
          meta: {
            checkLogin: true,
            title: '異動紀錄',
          }
        },
        {
          path: '/wallet/search',
          name: 'walletSearch',
          component: () => import('@/views/Wallet/Search'),
          meta: {
            checkLogin: true,
            title: '異動查詢',
          }
        },
        {
          path: '/wallet/withdraw',
          name: 'walletWithdraw',
          component: () => import('@/views/Wallet/Withdraw'),
          meta: {
            checkLogin: true,
            title: '提領列表',
          }
        },
        {
          path: '/wallet/report',
          name: 'walletReport',
          component: () => import('@/views/Wallet/Report'),
          meta: {
            checkLogin: true,
            title: '異動統計',
          }
        },
        {
          path: '/game/index',
          name: 'gameIndex',
          component: () => import('@/views/Game/Index'),
          meta: {
            checkLogin: true,
            title: '游戲控端',
          }
        },
        {
          path: '/game/report',
          name: 'gameReport',
          component: () => import('@/views/Game/Report'),
          meta: {
            checkLogin: true,
            title: '盈虧查詢',
          }
        },
        {
          path: '/game/nowOrders',
          name: 'gameNowOrders',
          component: () => import('@/views/Game/nowOrders'),
          meta: {
            checkLogin: true,
            title: '即時注單',
          }
        },
        {
          path: '/game/orders',
          name: 'gameOrders',
          component: () => import('@/views/Game/Orders'),
          meta: {
            checkLogin: true,
            title: '投注訂單',
          }
        },
        {
          path: '/game/number',
          name: 'gameNumber',
          component: () => import('@/views/Game/Number'),
          meta: {
            checkLogin: true,
            title: '回合管理',
          }
        },
        {
          path: '/game/setting',
          name: 'gameSetting',
          component: () => import('@/views/Game/Setting'),
          meta: {
            checkLogin: true,
            title: '游戲設定',
          }
        },
        {
          path: '/game/open',
          name: 'gameOpen',
          component: () => import('@/views/Game/Open'),
          meta: {
            checkLogin: true,
            title: '開獎結果',
          }
        },
        {
          path: '/game/config',
          name: 'gameConfig',
          component: () => import('@/views/Game/Config'),
          meta: {
            checkLogin: true,
            title: '基本設定',
          }
        },
        {
          path: '/lottery/number',
          name: 'lotteryNumber',
          component: () => import('@/views/Lottery/Number'),
          meta: {
            checkLogin: true,
            title: '回合管理',
          }
        },
        {
          path: '/lottery/setting',
          name: 'lotterySetting',
          component: () => import('@/views/Lottery/Setting'),
          meta: {
            checkLogin: true,
            title: '游戲設定',
          }
        },
        {
          path: '/lottery/open',
          name: 'lotteryOpen',
          component: () => import('@/views/Lottery/Open'),
          meta: {
            checkLogin: true,
            title: '開獎結果',
          }
        },
        {
          path: '/lottery/played',
          name: 'lotteryPlayed',
          component: () => import('@/views/Lottery/Played'),
          meta: {
            checkLogin: true,
            title: '玩法設定',
          }
        },
        {
          path: '/recharge/payment',
          name: 'rechargePayment',
          component: () => import('@/views/Recharge/Payment'),
          meta: {
            checkLogin: true,
            title: '金流列表',
          }
        },
        {
          path: '/recharge/index',
          name: 'rechargeIndex',
          component: () => import('@/views/Recharge/Index'),
          meta: {
            checkLogin: true,
            title: '儲值紀錄',
          }
        },
        {
          path: '/lockming/index',
          name: 'lockmingIndex',
          component: () => import('@/views/Lockming/Index'),
          meta: {
            checkLogin: true,
            title: '鎖倉挖礦',
          }
        },
        {
          path: '/lockming/log',
          name: 'lockmingLog',
          component: () => import('@/views/Lockming/Log'),
          meta: {
            checkLogin: true,
            title: '鎖倉訂單',
          }
        },
        {
          path: '/message/index',
          name: 'messageIndex',
          component: () => import('@/views/Message/Index'),
          meta: {
            checkLogin: true,
            title: '私訊列表',
          }
        },
        {
          path: '/article/activity',
          name: 'articleActivity',
          component: () => import('@/views/Article/Activity'),
          meta: {
            checkLogin: true,
            title: '活動設定',
          }
        },
        {
          path: '/article/notice',
          name: 'articleNotice',
          component: () => import('@/views/Article/Notice'),
          meta: {
            checkLogin: true,
            title: '公告列表',
          }
        },
        {
          path: '/activity/log',
          name: 'ActivityLog',
          component: () => import('@/views/Activity/Log'),
          meta: {
            checkLogin: true,
            title: '活動紀錄',
          }
        },
        {
          path: '/article/banner',
          name: 'articleBanner',
          component: () => import('@/views/Article/Banner'),
          meta: {
            checkLogin: true,
            title: '横幅设定',
          }
        },
        {
          path: '/system/config',
          name: 'systemConfig',
          component: () => import('@/views/System/Config'),
          meta: {
            checkLogin: true,
            title: '基本設定',
          }
        },
        {
          path: '/url/index',
          name: 'UrlIndex',
          component: () => import('@/views/Url/Index'),
          meta: {
            checkLogin: true,
            title: '域名管理',
          }
        },
        {
          path: '/url/log',
          name: 'UrlLog',
          component: () => import('@/views/Url/Log'),
          meta: {
            checkLogin: true,
            title: '访问纪录',
          }
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login'),
      meta: {
        checkLogin: false,
        title: '登入',
      }
    },
  ]
})

//路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.checkLogin == true) {
    //判断token是否存在
    if (!localStorage.getItem('X-Token')) {
      router.push({
        name: 'Login'
      })
      return false;
    }
  }
  next();
})

router.afterEach((to, from) => {
  //如果登录的话 获取用户信息
  if (to.meta.checkLogin) {
    axios.get("/info").then(res => {
      const data = res.data;
      if (data.code == 200) {
        store.state.user = data.data;

        localStorage.setItem('user', JSON.stringify(data.data));
      }
    })
  }
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js